import React from 'react'

interface IconfontProps {
    name: string
    className?: string
    onClick?: (e: any) => void
    size?: number
    style?: any
}

const Iconfont: React.FC<IconfontProps> = props => {
    return (
        <svg
            onClick={(e: any) => props.onClick && props.onClick(e)}
            className={`${props.className} icon`}
            aria-hidden="true"
            style={{ ...props.style, fontSize: `${props.size || 12}px` }}
        >
            <use xlinkHref={'#' + props.name}></use>
        </svg>
    )
}

export default Iconfont
